import Icon from '../components/Icon.vue'

Icon.register({"tree":{"width":384,"height":512,"paths":[{"d":"M377.3 375.4L293.9 288H328C349 288 359.9 262.8 345.4 247.5L262.8 160H296C316.9 160 327.9 135 313.6 119.7L209.6 7.7C200.1-2.5 183.9-2.6 174.4 7.7L70.4 119.7C56.2 135 67 160 88 160H121.2L38.6 247.5C24.1 262.8 35 288 56 288H90.1L6.7 375.4C-7.9 390.7 2.9 416 24 416H144C144 448.8 132.8 465.3 110 483.5 98.2 492.9 104.9 512 120 512H264C279.1 512 285.8 492.9 274 483.5 254.2 467.7 240 451.8 240 416V416H360C381 416 391.9 390.7 377.3 375.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tree.js
// module id = JkcP
// module chunks = 0